import {Injectable} from '@angular/core';
import {StateService} from "@uirouter/core";
import {HttpClient} from "@angular/common/http";
import * as _ from 'lodash';

import {AppAlertService} from "./app-alert.service";
import {DatabaseService} from "./database.service";
import {ParametersService} from "./parameters.service";
import {SubtitlesService} from "./subtitles.service";
import {UserService} from "./user.service";
import {ZonesService} from "./zones.service";
import {
    IntervalElement,
    ZoneInterval,
    ZoneIntervalView,
    ZoneSchedule, ZonesData,
    ZoneViewData, ZoneViewId
} from "../models";


@Injectable({
    providedIn: 'root'
})
export class ZoneScheduleService {
    private copyZonesTable: ZoneViewData[] = [];
    firstInterval: ZoneIntervalView;
    firstIntervals: ZoneInterval[] = [];
    firstSetTemp: number | '' = '';
    isSendingSchedule = false;
    name: string = '';
    schedule: ZoneSchedule;
    secondInterval: ZoneIntervalView;
    secondIntervals: ZoneInterval[] = [];
    secondSetTemp: number | '' = '';
    selectedAll: boolean = false;
    setInZones: ZoneViewData[] = [];
    showFirstInterval: boolean = false;
    showFirstSetTemp: boolean = false;
    showSecondInterval: boolean = false;
    showSecondSetTemp: boolean = false;
    type: 'global' | 'local' | '' = '';
    private wrongFirstIntervals: boolean = false;
    private wrongSecondIntervals: boolean = false;
    zonesTable: ZoneViewData[] = [];


    constructor(
        private appAlert: AppAlertService,
        private database: DatabaseService,
        private http: HttpClient,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        private user: UserService,
        private zones: ZonesService,
    ) {
    }

    setSchedule(schedule: ZoneSchedule): void {
        this.setIntervals(schedule);

        if (schedule.index >= 0) {
            this.type = 'global';
            this.name = this.zones.getScheduleName(schedule.index, 'long');
            this.setInZones = this.searchSetInZones(schedule.index);
        } else {
            this.type = 'local';
            this.name = this.subtitles.setSubtitle(1682);
            this.setInZones = [];
        }
        this.schedule = _.cloneDeep(schedule);

        this.$state.go('zone_schedule_settings', {
            selectedModuleHash: this.parameters.selectedModuleHash
        });
    }

    searchSetInZones(index: number): ZoneViewData[] {
        const zones: ZoneViewData[] = [];

        this.database.zones.getValue()['elements'].forEach(val => {
            if (val === null) return;

            if (val.zone.zoneState === 'noAlarm'
                && val.mode.scheduleIndex === index
                && val.mode.mode === 'globalSchedule') {
                zones.push(val);
            }
        });

        return zones;
    }

    setDay(index: number): void {
        this.schedule.p0Days[index] = this.schedule.p0Days[index] === '1' ? '0' : '1';
        this.schedule.p1Days[index] = this.schedule.p1Days[index] === '1' ? '0' : '1';
    }

    showHideSetTemp(element: IntervalElement,
                    value: number,
                    type: 'show' | 'save' | 'hide') {
        if (type === 'show') {
            if (element === 'first') {
                this.showFirstSetTemp = true;
                this.firstSetTemp = value;
            } else if (element === 'second') {
                this.showSecondSetTemp = true;
                this.secondSetTemp = value;
            }
        } else if (type === 'save') {
            if (element === 'first') {
                this.schedule.p0SetbackTemp = Math.round(value);
                this.showFirstSetTemp = false;
                this.firstSetTemp = '';
            } else if (element === 'second') {
                this.schedule.p1SetbackTemp = Math.round(value);
                this.showSecondSetTemp = false;
                this.secondSetTemp = '';
            }
        } else if (type === 'hide') {
            if (element === 'first') {
                this.showFirstSetTemp = false;
                this.firstSetTemp = '';
            } else if (element === 'second') {
                this.showSecondSetTemp = false;
                this.secondSetTemp = '';
            }
        }
    }

    private setIntervals(schedule: ZoneSchedule): void {
        this.firstIntervals = [];
        this.secondIntervals = [];

        for (let i = 0; i < 3; i++) {
            if ((schedule.p0Intervals[i].start <= 1440 && schedule.p0Intervals[i].stop <= 1440) && !(schedule.p0Intervals[i].start === 0 && schedule.p0Intervals[i].stop === 0)) {
                this.firstIntervals.push({
                    start: schedule.p0Intervals[i].start,
                    stop: schedule.p0Intervals[i].stop,
                    temp: schedule.p0Intervals[i].temp,
                })
            }

            if ((schedule.p1Intervals[i].start <= 1440 && schedule.p1Intervals[i].stop <= 1440) && !(schedule.p0Intervals[i].start === 0 && schedule.p0Intervals[i].stop === 0)) {
                this.secondIntervals.push({
                    start: schedule.p1Intervals[i].start,
                    stop: schedule.p1Intervals[i].stop,
                    temp: schedule.p1Intervals[i].temp,
                })
            }
        }

        this.firstIntervals.sort(this.order);
        this.secondIntervals.sort(this.order);
    }

    changeHour(element: string, val: number): string {
        let newValue: number;
        const newElement = parseInt(element);

        if (newElement + val > 24) {
            newValue = 0;
        } else if (newElement + val < 0) {
            newValue = 25 + val;
        } else {
            newValue = newElement + val;
        }

        if (newValue === 24) {
            if (newElement === parseInt(this.firstInterval?.stopHour)) {
                this.firstInterval.stopMinute = this.double(0);
            } else if (newElement === parseInt(this.secondInterval?.stopHour)) {
                this.secondInterval.stopMinute = this.double(0);
            } else if (newElement === parseInt(this.firstInterval?.startHour)) {
                this.firstInterval.startMinute = this.double(0);
            } else if (newElement === parseInt(this.secondInterval?.startHour)) {
                this.secondInterval.startMinute = this.double(0);
            }
        }

        return this.double(newValue);
    }
    changeMinute(element: string, val: number): string {
        let newValue = -1;
        const newElement = parseInt(element);

        if (newElement === 59) {
            newValue = val > 0 ? 15 : 45;
        } else if (newElement + val > 59) {
            newValue = 0;
        } else if (newElement + val < 0) {
            newValue = 60 + val;
        } else {
            newValue = newElement + val;
        }

        return this.double(newValue);
    }

    private double(val: number): string {
        return ('0' + val).slice(-2);
    }

    private order(a: ZoneInterval, b: ZoneInterval): number {
        if (a.start < b.start)
            return -1;
        if (a.start > b.start)
            return 1;
        return 0;
    }

    setInterval(element: IntervalElement, index: number): void {
        if (element === 'first') {
            this.firstInterval = {
                startHour: this.double(Math.floor(this.firstIntervals[index].start / 60)),
                startMinute: this.double(this.firstIntervals[index].start % 60),
                stopHour: this.double(Math.floor(this.firstIntervals[index].stop / 60)),
                stopMinute: this.double(this.firstIntervals[index].stop % 60),
                temp: this.firstIntervals[index].temp,
                index,
            };

            this.showFirstInterval = true;
        } else if (element === 'second') {
            this.secondInterval = {
                startHour: this.double(Math.floor(this.secondIntervals[index].start / 60)),
                startMinute: this.double(this.secondIntervals[index].start % 60),
                stopHour: this.double(Math.floor(this.secondIntervals[index].stop / 60)),
                stopMinute: this.double(this.secondIntervals[index].stop % 60),
                temp: this.secondIntervals[index].temp,
                index,
            };
            this.showSecondInterval = true;
        }
    }

    hideInterval(element: IntervalElement): void {
        if (element === 'first') {
            this.showFirstInterval = false;
            this.firstInterval = undefined;
        } else if (element === 'second') {
            this.showSecondInterval = false;
            this.secondInterval = undefined;
        }
    }

    saveInterval(element: IntervalElement): void {
        if (element === 'first') {
            if (this.checkInterval(this.firstInterval)) {
                this.firstIntervals[this.firstInterval.index] = {
                    start: parseInt(this.firstInterval.startHour) * 60 + parseInt(this.firstInterval.startMinute),
                    stop: parseInt(this.firstInterval.stopHour) * 60 + parseInt(this.firstInterval.stopMinute),
                    temp: this.firstInterval['temp']
                };
                this.showFirstInterval = false;
                this.firstInterval = undefined;
            } else {
                this.appAlert.showAppAlert(this.subtitles.setSubtitle(1783),
                    this.subtitles.setSubtitle(475), null, false, null);
            }
        } else if (element === 'second') {
            if (this.checkInterval(this.secondInterval)) {
                this.secondIntervals[this.secondInterval.index] = {
                    start: parseInt(this.secondInterval.startHour) * 60 + parseInt(this.secondInterval.startMinute),
                    stop: parseInt(this.secondInterval.stopHour) * 60 + parseInt(this.secondInterval.stopMinute),
                    temp: this.secondInterval.temp
                };
                this.showSecondInterval = false;
                this.secondInterval = undefined;
            } else {
                this.appAlert.showAppAlert(this.subtitles.setSubtitle(1783),
                    this.subtitles.setSubtitle(475), null, false, null);
            }
        }
        this.firstIntervals.sort(this.order);
        this.secondIntervals.sort(this.order);
        this.checkIntervals(element);
    }

    private checkInterval(interval: ZoneIntervalView): boolean {
        const start = parseInt(interval.startHour) * 60 + parseInt(interval.startMinute);
        const stop = parseInt(interval.stopHour) * 60 + parseInt(interval.stopMinute);

        return start < stop;
    }

    deleteInterval(element: IntervalElement, index: number): void {
        if (element === 'first') {
            this.firstIntervals.splice(index, 1);
        } else if (element === 'second') {
            this.secondIntervals.splice(index, 1);
        }

        this.firstIntervals.sort(this.order);
        this.secondIntervals.sort(this.order);
        this.checkIntervals(element);
    }

    addInterval(element: IntervalElement): void {
        const table = element === 'first'
            ? this.firstIntervals : this.secondIntervals;

        if (table.length) {
            const nextStart = table[table.length - 1].stop;

            if (nextStart === 1440 || nextStart === 0) {
                return;
            }

            table[table.length] = {
                start: nextStart,
                stop: table[table.length - 1].stop + 60 >= 1440
                    ? 1440
                    : table[table.length - 1].stop + 60,
                temp: 200
            };
        } else {
            table[0] = {
                start: 0,
                stop: 60,
                temp: 200
            };
        }

        table.sort(this.order);
        this.checkIntervals(element);
    }

    private checkIntervals(element: IntervalElement): void {
        let table: ZoneInterval[] = [];

        if (element === 'first') {
            table = this.firstIntervals;
            this.wrongFirstIntervals = false;
        } else {
            table = this.secondIntervals;
            this.wrongSecondIntervals = false;
        }

        table.forEach(val => {
            val.wrongInterval = false;
        });

        if (table.length <= 1) return;

        table.forEach((val, key) => {
            if (key + 1 < table.length) {
                if (table[key + 1].start < (table[key].stop === 0 ? 1440 : table[key].stop)) {
                    table[key + 1].wrongInterval = true;
                    table[key].wrongInterval = true;
                    if (element === 'first') {
                        this.wrongFirstIntervals = true;
                    } else {
                        this.wrongSecondIntervals = true;
                    }
                }
            } else if (table[table.length - 1].start < (table[0].stop === 0 ? 1440 : table[0].stop)) {
                table[table.length - 1].wrongInterval = true;
                table[0].wrongInterval = true;
                if (element === 'first') {
                    this.wrongFirstIntervals = true;
                } else {
                    this.wrongSecondIntervals = true;
                }
            }
        });
    }

    private getListZone(): void {
        const table: ZoneViewData[] = _.cloneDeep(this.database.zones.getValue()['elements']);
        this.zonesTable = [];

        table.forEach((val) => {
            if (val.zone.zoneState === 'noAlarm') {
                val['status'] = 'empty';
                if (val.description.id === this.zones.selectedZone.description['id']) {
                    val['status'] = 'disabled';
                } else {
                    this.setInZones.forEach((zone) => {
                        if (val.description.id === zone.description.id) {
                            val['status'] = 'disabled';
                        }
                    })
                }
                this.zonesTable.push(val);
            }
        });

        this.zonesTable = this.zonesTable.sort(function (a, b) {
            return a.zone.index - b.zone.index;
        });

        this.copyZonesTable = _.cloneDeep(this.zonesTable);
    }

    selectZone(index: number | 'all'): void {
        if (index === 'all') {
            this.selectedAll = !this.selectedAll;

            this.zonesTable.forEach((val) => {
                if (val.status !== 'disabled') {
                    val.status = this.selectedAll ? 'selected' : 'empty';
                }
            });
        } else if (this.zonesTable[index].status !== 'disabled') {
            this.selectedAll = false;
            this.zonesTable[index].status = this.zonesTable[index].status === 'empty'
                ? 'selected' : 'empty';
        }
    }

    checkSchedule(): void {
        if (this.wrongFirstIntervals || this.wrongSecondIntervals) {
            this.appAlert.showAppAlert(this.subtitles.setSubtitle(1784),
                this.subtitles.setSubtitle(475), null, false, null);
        } else if (this.schedule.index >= 0) {
            this.searchSetInZones(this.schedule.index);
            this.selectedAll = false;
            this.getListZone();

            this.$state.go('select_zones', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
        } else {
            this.returnSchedule('local_schedule');
        }
    }

    private getZonesId(zonesTable: ZoneViewData[]) {
        const zonesId: ZoneViewId[] = [];

        if (zonesTable.length) {
            zonesTable.forEach((val) => {
                if (this.selectedAll || val.status === 'selected' || val.status === 'disabled'){
                    zonesId.push({
                        modeId: val.mode.id,
                        zoneId: val.zone.id
                    });
                }
            });
        }

        return zonesId;
    }

    private isZonesData(data: {} | ZonesData): data is ZonesData {
        return Object.keys(data).length > 0;
    }
    private changeScheduleName(index: number, name: string): void {
        const zonesData = this.database.zones.getValue();

        if (
            index >= 0 &&
            name.length &&
            this.isZonesData(zonesData) &&
            index < zonesData.globalSchedules.elements.length
        ) {
            zonesData.globalSchedules.elements[index].name = name;
            this.database.zones.next(zonesData);
        }
    }

    private setScheduleDuringChange(zoneId: number, setInZones: ZoneViewId[]): void {
        if (setInZones.length) {
            setInZones.forEach((zone) => {
                this.zones.setDuringChange(zone.zoneId);
            });
        } else {
            this.zones.setDuringChange(zoneId);
        }
    }

    returnSchedule(scheduleType: 'local_schedule' | 'global_schedule'): void {
        if (this.parameters.demoAccount()) {
            this.appAlert.showAppAlert(this.subtitles.setSubtitle(3529),
                this.subtitles.setSubtitle(475), null, false, null);
            return;
        }

        const scheduleName = (this.name.length !== 0)
        && (this.name !== this.zones.getScheduleName(this.schedule.index, 'long'))
            ? this.name : '';

        [...this.firstIntervals, ...this.secondIntervals].forEach(interval => {
            delete interval.wrongInterval;
        });

        const data = {
            modeId: this.zones.selectedZone['mode'].id,
            schedule: {
                id: this.schedule.id,
                index: this.schedule.index,
                p0Days: this.schedule.p0Days,
                p0Intervals: this.firstIntervals,
                p0SetbackTemp: this.schedule.p0SetbackTemp,
                p1Days: this.schedule.p1Days,
                p1Intervals: this.secondIntervals,
                p1SetbackTemp: this.schedule.p1SetbackTemp,
            },
        } as any;

        const setInZones = this.schedule.index >= 0
            ? this.getZonesId(this.zonesTable)
            : [];

        if (scheduleType === 'global_schedule') {
            data.scheduleName = this.schedule.index >= 0 ? scheduleName : '';
            data.setInZones = setInZones;
        }

        this.zones.showZonesView = true;

        const zoneId = this.zones.selectedZone['zone'].id;
        this.isSendingSchedule = true;

        this.http.post(`/api/v1/users/${this.user.user_id}/modules/${
            this.parameters.selectedModuleHash}/zones/${zoneId}/${scheduleType}`, data)
            .subscribe(() => {
                if (scheduleName.length) this.changeScheduleName(this.schedule.index, scheduleName);

                this.setScheduleDuringChange(zoneId, setInZones);
                this.isSendingSchedule = false;

                this.$state.go('home', {
                    selectedModuleHash:
                    this.parameters.selectedModuleHash
                });
            });
    }
}
